import { useEffect } from 'react'

import { isTokenValid } from '@/utils/auth'
import { GlobalLoaderComponent } from '@/utils/globalLoaders/GlobalLoaders'
import { debug } from '@/utils/logger'

import { useAuth } from './api/useAuth'

export const AuthLoader: GlobalLoaderComponent = () => {
  const { token, authenticate, unAuthenticate } = useAuth()

  useEffect(() => {
    if (!token) {
      unAuthenticate()
    }
    if (token) {
      if (!isTokenValid(token)) {
        // run refresh flow
        debug('Token expired')
        // remove next line after implementing refresh flow
        unAuthenticate()
      } else {
        if (!window.location.pathname.includes('login-as')) {
          authenticate(token)
        }
      }
    }
  }, [authenticate, token, unAuthenticate])

  return null
}
